import axios from 'axios'
import api from "@/helpers/api";
import {convertSecondsToTime} from '@/helpers/formatted.js';
import router from "@/router";
import store from "@/store";
import App from "@/App";
const state = {
    item: {},
    months: [],
    plan: [],
}

// getters
const getters = {
}

const actions = {
    getItem(context, data) {
        return new Promise((resolve, reject) => {
            context.commit('finishTimer');
            axios.get(process.env.VUE_APP_API_PATH+'/workers/'+data.id,api.axiosConfig({})).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                context.commit('setItem', response.data.result);
                if(response.data.result.item.timer.leave.timeStart > 0){
                    context.dispatch('startTimer', {type: 'leave',timeStart: response.data.result.item.timer.leave.timeStart});
                } else if(response.data.result.item.timer.worked.timeStart > 0){
                    context.commit('auth/setWorkOvertimeNoComment',{id:response.data.result.item.timer.worked.eventId},{root:true})
                    context.dispatch('startTimer', {type: 'worked',timeStart: response.data.result.item.timer.worked.timeStart});
                }
                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
    setLeave(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/events/'+data.id,api.axiosConfig({
                type: 'leave'
            })).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                context.commit('setItem', response.data.result);
                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
    takeHoliday(context, data) {
        return new Promise((resolve, reject) => {
            let params = new FormData();
            for(let name in data){
                params.append(name, data[name]);
            }
            axios.post(process.env.VUE_APP_API_PATH+'/events/',params,api.axiosConfig({
                type: 'holiday',
            })).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                context.commit('setCurrentMonthEvents', response.data.result);
                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
    leave(context, data) {
        return new Promise((resolve, reject) => {
            let params = new FormData();
            for(let name in data){
                params.append(name, data[name]);
            }
            axios.post(process.env.VUE_APP_API_PATH+'/events/',params,api.axiosConfig({
                type: 'leave',
                timeType: data.timeType,
            })).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                if(data.timeType == 'end'){
                    context.commit('setCurrentMonthEvents', response.data.result);
                    context.commit('finishTimer');
                } else {
                    context.dispatch('startTimer', {type: 'leave'});
                }


                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
    workOvertime(context, data) {
        return new Promise((resolve, reject) => {
            let params = new FormData();
            for(let name in data){
                params.append(name, data[name]);
            }
            axios.post(process.env.VUE_APP_API_PATH+'/events/',params,api.axiosConfig({
                type: 'worked',
                timeType: data.timeType,
                workOvertimeNoComment: data.workOvertimeNoComment,
            })).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                if(data.timeType == 'end'){
                    context.commit('setCurrentMonthEvents', response.data.result);
                    context.commit('finishTimer');
                    if(response.data.result.eventId){
                        context.commit('auth/setWorkOvertimeNoComment',{id: response.data.result.eventId},{root:true})
                    }
                } else {
                    context.dispatch('startTimer', {type: 'worked'});
                }

                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
    startTimer(context, data) {
        let time = 0;
        if(!!data && data.time) {
            time = data.time;
        }
        if(data.type === 'leave') {
            context.commit('setTimeLeave',data.timeStart ? data.timeStart : (new Date().getTime() / 1000).toFixed(0));
        }
        if(data.type === 'worked'){
            context.commit('setTimeWorked',data.timeStart ? data.timeStart : (new Date().getTime() / 1000).toFixed(0));
        }
        let timer = setInterval(function () {
            if(data.type === 'leave') {
                context.commit('incrementTimerLeave');
            }
            if(data.type === 'worked'){
                context.commit('incrementTimerWorked');
            }
        }, 1000);
        if(data.type === 'leave' && timer) {
            context.commit('setIntervalLeave', timer);
        }
        if(data.type === 'worked' && timer){
            context.commit('setIntervalWorked', timer);
        }
    },
    cancelHoliday(context, data) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_PATH+'/events/'+data,{},api.axiosConfig({
                type: 'cancelHoliday',
            })).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                context.commit('cancelHoliday', data);
                context.commit('setCurrentMonthEvents', response.data.result);
                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
    setWorkTime(context, data) {
        return new Promise((resolve, reject) => {
            data.type = 'setWorkTime';
            axios.post(process.env.VUE_APP_API_PATH+'/workers/',{},api.axiosConfig(data)).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                context.commit('auth/setWorkTime', data, {root: true});
                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
    socketEvent(context, data) {
        switch (data) {
            case 'updateWorker':
                let item = {};
                let id = '';
                let menuList = store.state.menus.itemsTop
                let user = store.state.auth.user
                console.log(menuList)
                console.log(user)
                if (router.currentRoute._value.params.id) {
                    id = router.currentRoute._value.params.id;
                }

                if (!id && Object.values(menuList)[0]) {
                    for(let m in menuList){
                        if(user.id == menuList[m].userId){
                            item = menuList[m];
                        }
                    }
                } else {
                    for(let m in menuList){
                        if(id == menuList[m].id){
                            item = menuList[m];
                        }
                    }
                }
                context.dispatch('workers/getItem', {id:item.id},{root:true});
                break;
            default:
                console.log(data)
                break;
        }
    }
}

const mutations = {
    setItem(state, data) {
        if(typeof data === 'object' && data.item !== undefined) {
            state.item = data.item;
        }
        if(typeof data === 'object' && data.months !== undefined) {
            state.months = data.months;
        }
        if(typeof data === 'object' && data.plan !== undefined) {
            state.plan = data.plan;
        }
    },
    toggleMonthOpened(state, data){
        state.months[data].isOpen = !state.months[data].isOpen;
    },
    setLeave(state, data){

    },
    setCurrentMonthEvents(state, data) {
        for(let m in state.months) {
            if(state.months[m].id == data.item.id) {
                state.months[m].days = data.item.days
            }
        }
        state.item.days = data.user.days;
        state.item.time = data.user.time;
        if(typeof data === 'object' && data.plan !== undefined) {
            state.plan = data.plan;
        }
    },
    cancelHoliday(state, data){
        for(let m in state.months) {
            for(let d in state.months[m].days) {
                for(let e in state.months[m].days[d].events) {
                    if(state.months[m].days[d].events[e].id == data) {
                        state.months[m].days[d].events.splice(e, 1);
                    }
                }
            }
        }
        for(let e in state.plan) {
            if(state.plan[e].id == data) {
                state.plan.splice(e, 1);
            }
        }
    },
    incrementTimerLeave(state, data){
        let time = convertSecondsToTime((new Date().getTime() / 1000).toFixed(0) - state.item.timer.leave.timeStart);
        state.item.timer.leave.time = state.item.timer.leave.timeStart ? time.hours+':'+time.minutes+':'+time.seconds : false;
    },
    incrementTimerWorked(state, data){
        let time = convertSecondsToTime((new Date().getTime() / 1000).toFixed(0) - state.item.timer.worked.timeStart);
        state.item.timer.worked.time = state.item.timer.worked.timeStart ? time.hours+':'+time.minutes+':'+time.seconds : false;
    },
    setIntervalLeave(state, data){
        state.item.timer.leave.timerId = data
    },
    setIntervalWorked(state, data){
        state.item.timer.worked.timerId = data
    },
    setTimeLeave(state, data){
        state.item.timer.leave.timeStart = data
    },
    setTimeWorked(state, data){
        state.item.timer.worked.timeStart = data
    },
    finishTimer(state, data){
        if(state.item.timer){
            clearInterval(state.item.timer.leave.timerId);
            clearInterval(state.item.timer.worked.timerId);
            state.item.timer.leave.timerId = false;
            state.item.timer.worked.timerId = false;
            state.item.timer.leave.time = false;
            state.item.timer.worked.time = false;
            state.item.timer.leave.timeStart = 0;
            state.item.timer.worked.timeStart = 0;
        }

    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
